import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeContext } from '../../context/ThemeContext';
import { useLocation } from '@reach/router';
import OmTextAreaWrapper from '../forms/OmTextAreaWrapper'
import './CustomerSatisfactionSurvey.scss'
import OmButton from '../forms/OmButton';

import {
    setCustomerFeedbackValue,
    setCustomerQueryParams,
    submitCustomerFeedback
} from '@om/redux/actions/customerSatisfactionSurvey/customerSatisfactionSubmitForm'

import {
    getButtonText,
    getInputDisabled,
    getIsApiCallSuccess,
    getCustomerFeedback,
    getCustomerSatisfactionSubmitPageInvalid,
} from '@om/redux/selectors/customerSatisfactionSurvey/customerSatisfactionSubmitForm'

function buttonDisabled(formInvalid, inputDisabled) {
    if(formInvalid || inputDisabled) {
        return true;
    }
    return false;
}

const CustomerSatisfactionSurvey = ({
    slot
}) => {
    const dispatch = useDispatch();
    const {
        buttonText,
        formSuccess,
        formInvalid,
        inputDisabled,
        customerFeedback,
    } = useSelector(
        createStructuredSelector({
            buttonText: getButtonText,
            formSuccess: getIsApiCallSuccess,
            formInvalid: getCustomerSatisfactionSubmitPageInvalid,
            inputDisabled: getInputDisabled,
            customerFeedback: getCustomerFeedback,
        })
    );
    const theme = React.useContext(ThemeContext);
    const location = useLocation();
    
    useEffect(() => {
        const params  = new URLSearchParams(location.search.substring(1));
    
        const queryParams = {
            intId: params.get('int_id'),
            sysId: params.get('sys_id'),
            score: params.get('score'),
            qId: params.get('q_id')
        }

        dispatch(setCustomerQueryParams(queryParams));
    }, [location, dispatch]);

    return (
        <div className={`om-customer-satisfaction-survey ${theme}`} slot={slot}>
            <div className="customer-satisfaction-survey-wrapper">
                <OmTextAreaWrapper
                    label="Please provide reasons for your rating (max 2000 characters)"
                    placeholder="Type your message"
                    maxLength={2100}
                    rows={10}
                    disabled={inputDisabled}
                    labelAlwaysShow={true}
                    isResizable={false}
                    reduxValue={customerFeedback}
                    onPersist={val => dispatch(setCustomerFeedbackValue(val))}
                />
                <div className="center">
                    <OmButton
                        slot="end-button"
                        type="primary"
                        size="small"
                        text={buttonText}
                        withIcon={formSuccess}
                        iconName="check_circle"
                        disabled={buttonDisabled(formInvalid, inputDisabled)}
                        onClick={() => dispatch(submitCustomerFeedback())}
                    />
                </div>
            </div>
        </div>
    );
};

export default CustomerSatisfactionSurvey;
